import { Accordion, ActionIcon, Avatar, Box, Button, Group, Menu, Stack, Text } from '@mantine/core';
import { Plus, X } from 'react-feather';
import type { PartnerContactWithCohortCount } from '../../../../types';

interface PrimaryContactsSectionProps {
  selectedContacts: PartnerContactWithCohortCount[];
  availableContacts: PartnerContactWithCohortCount[];
  contacts: PartnerContactWithCohortCount[];
  handleAddContact: (contactId: string | null) => void;
  handleRemoveContact: (contactId: string) => void;
  classes: Record<string, string>;
}

export function PrimaryContactsSection({
  selectedContacts,
  availableContacts,
  contacts,
  handleAddContact,
  handleRemoveContact,
  classes,
}: PrimaryContactsSectionProps) {
  return (
    <Accordion.Item value="primary-contacts">
      <Accordion.Control>
        <Text fw={600}>Primary Partner Contacts</Text>
      </Accordion.Control>
      <Accordion.Panel>
        <Stack gap="md">
          {selectedContacts.length > 0 ? (
            <Stack gap="sm">
              {selectedContacts.map((contact) => (
                <Group key={contact.id} className={classes.contactRow} justify="space-between">
                  <Group gap="sm">
                    <Avatar size="md" radius="xl" color="blue">
                      {contact.first_name[0]}
                      {contact.last_name[0]}
                    </Avatar>
                    <Box>
                      <Text size="sm" fw={500}>
                        {contact.first_name} {contact.last_name}
                      </Text>
                      <Text size="xs" c="dimmed">
                        {contact.job_title || 'No title'} &bull; {contact.email}
                      </Text>
                    </Box>
                  </Group>
                  <ActionIcon variant="subtle" color="gray" onClick={() => handleRemoveContact(contact.id)}>
                    <X size={16} />
                  </ActionIcon>
                </Group>
              ))}
            </Stack>
          ) : (
            <Text size="sm" c="dimmed">
              No primary contacts selected
            </Text>
          )}

          <Menu shadow="md" width={300} position="bottom-start">
            <Menu.Target>
              <Button variant="light" leftSection={<Plus size={16} />} disabled={availableContacts.length === 0}>
                Add Partner Contact
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              {availableContacts.length > 0 ? (
                availableContacts.map((contact) => (
                  <Menu.Item
                    key={contact.id}
                    onClick={() => handleAddContact(contact.id)}
                    leftSection={
                      <Avatar size="sm" radius="xl" color="blue">
                        {contact.first_name[0]}
                        {contact.last_name[0]}
                      </Avatar>
                    }
                  >
                    <Box>
                      <Text size="sm" fw={500}>
                        {contact.first_name} {contact.last_name}
                      </Text>
                      <Text size="xs" c="dimmed">
                        {contact.job_title || 'No title'}
                      </Text>
                    </Box>
                  </Menu.Item>
                ))
              ) : (
                <Menu.Item disabled>
                  {contacts.length > 0 ? 'All partner contacts have been added' : 'No partner contacts available'}
                </Menu.Item>
              )}
            </Menu.Dropdown>
          </Menu>
        </Stack>
      </Accordion.Panel>
    </Accordion.Item>
  );
}
